import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "icn-graphics-text-ticker",
  templateUrl: "./text-ticker.component.html",
  styleUrls: ["./text-ticker.component.scss"],
})
export class GraphicsTextTickerComponent {
  @Input() isTicker = false;
  @Input() tickerSpeed = 0;
  @Input() tickerDirection = 0;
  @Input() tickerIsLoop = false;

  @Output() isTickerChange = new EventEmitter<boolean>();
  @Output() tickerSpeedChange = new EventEmitter<number>();
  @Output() tickerDirectionChange = new EventEmitter<number>();
  @Output() tickerIsLoopChange = new EventEmitter<boolean>();

  onIsTickerClick() {
    this.isTicker = !this.isTicker;
    this.isTickerChange.emit(this.isTicker);
  }

  onTextTickerSpeedChange(val) {
    this.tickerSpeed = val;
    this.tickerSpeedChange.emit(val);
  }

  onTickerDirectionChange(val) {
    this.tickerDirection = val;
    this.tickerDirectionChange.emit(val);
  }

  onTickerIsLoopClick() {
    this.tickerIsLoop = !this.tickerIsLoop;
    this.tickerIsLoopChange.emit(this.tickerIsLoop);
  }
}
